module.exports = __webpack_public_path__ + "img/dongle_connect.283224ff.svg";